
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogPost from "../pages/blog/[slug]/page";
import CasePage from "../pages/cases/[slug]/page";
import CasesPage from "../pages/cases/page";
import Produtos from "../pages/produtos/page";
import TargetIncentivos from "../pages/produtos/target-incentivos/page";
import TargetPartnership from "../pages/produtos/target-partnership/page";
import TargetSales from "../pages/produtos/target-sales/page";
import InteligenciaDados from "../pages/produtos/inteligencia-dados/page";
import FabricaSoftware from "../pages/tecnologia/fabrica-software/page";
import Outsourcing from "../pages/tecnologia/outsourcing/page";
import Contato from "../pages/contato/page";
import Tecnologia from "../pages/tecnologia/page";
import PoliticaPrivacidade from "../pages/politica-privacidade/page";
import OutrasPoliticas from "../pages/outras-politicas/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPost />,
  },
  {
    path: "/cases",
    element: <CasesPage />,
  },
  {
    path: "/cases/:slug",
    element: <CasePage />,
  },
  {
    path: "/produtos",
    element: <Produtos />,
  },
  {
    path: "/produtos/target-incentivos",
    element: <TargetIncentivos />,
  },
  {
    path: "/produtos/target-partnership",
    element: <TargetPartnership />,
  },
  {
    path: "/produtos/target-sales",
    element: <TargetSales />,
  },
  {
    path: "/produtos/inteligencia-dados",
    element: <InteligenciaDados />,
  },
  {
    path: "/tecnologia/fabrica-software",
    element: <FabricaSoftware />,
  },
  {
    path: "/tecnologia/outsourcing",
    element: <Outsourcing />,
  },
  {
    path: "/contato",
    element: <Contato />,
  },
  {
    path: "/tecnologia",
    element: <Tecnologia />,
  },
  {
    path: "/politica-privacidade",
    element: <PoliticaPrivacidade />,
  },
  {
    path: "/outras-politicas",
    element: <OutrasPoliticas />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
